// extracted by mini-css-extract-plugin
export var alternate = "_a-h";
export var black = "_a-3";
export var blue = "_a-d";
export var blueLight = "_a-c";
export var brand = "_a-7";
export var error = "_a-9";
export var gray = "_a-6";
export var grayBlue = "_a-b";
export var iconWrapper = "_a-4";
export var indigo = "_a-e";
export var orange = "_a-g";
export var pink = "_a-f";
export var primary = "_a-0";
export var purple = "_a-8";
export var success = "_a-5";
export var warning = "_a-a";
export var white = "_a-1";
export var whiteSuccess = "_a-2";